module.exports = __webpack_public_path__ + "static/media/back9.51dcd29f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back9.jpg
// module id = 274
// module chunks = 0